import { useTooltip } from '../../components/Tooltip/useTooltip';
import { useHiddenBodyOverflow } from '../../hooks/useHiddenBodyOverflow';
import { useStores } from '../../stores/useStores';

import { type LoyaltyTutorialSteps } from './constants';

type TooltipParams = Parameters<typeof useTooltip>;

export function useLoyaltyProgramTutorial(
  step: LoyaltyTutorialSteps,
  placement: TooltipParams[0],
  offset: TooltipParams[1],
) {
  const { loyaltyProgramStore, featureManagerStore } = useStores();

  const isStepActive =
    loyaltyProgramStore.tutorialStep === step &&
    featureManagerStore.currentFeatureType === 'LoyaltyProgram' &&
    loyaltyProgramStore.loyaltyProgramTutorial.open;

  const { tooltipStyles, setReferenceElement, setPopperElement } = useTooltip(placement, offset);

  useHiddenBodyOverflow(isStepActive);

  return {
    showLoyaltyTutorial: isStepActive,
    tooltipStyles,
    setReferenceElement,
    setPopperElement,
  };
}
